<template>
  <div id="app">
    <div id="dark_theme_style_container"></div>
    <router-view />
  </div>
</template>

<script>
import { newsService } from "@/common/api.service";
import { userService } from './common/api.service';

export default {
  created: function () {
    // userService.current().then(() => {
    //   return;
    // }).catch(() => {
    //   this.$store.dispatch('auth/logout')
    // })
  },
  mounted() {
    this.themeInit();
    this.newsInit();
    setTimeout(() => {
      window.localStorage.setItem('is_first_page', '1');
    }, 2000);
  },
  watch: {
    $route (to, from) {
      setTimeout(() => {
        window.localStorage.setItem('is_first_page', '0');
      }, 2000);
    },
  },
  methods: {
    newsInit() {
      const skipPaths = ['/login', '/register', '/forget-pass']

      if (skipPaths.some(path => this.$route.path.startsWith(path))) {
        return
      }

      newsService.getnews().then(response => {
        let news_old_count = window.localStorage.getItem('news_old_count');
        let news_new_count = parseInt(response.data.data.length);

        if (news_old_count == null || news_old_count == undefined) {
          window.localStorage.setItem('news_old_count', 0);
        }

        window.localStorage.setItem('news_new_count', news_new_count);
      });
    },
    themeInit() {
      let theme = window.localStorage.getItem('AppUiTheme');

      if (theme == null || theme == undefined) {
          if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            this.setTheme('dark');
          } else {
            this.setTheme('light');
          }
      } else {
        this.setTheme(theme);
      }
    },

    setTheme(theme) {
      theme = String(theme);
      window.localStorage.setItem('AppUiTheme', theme);

      switch(theme) {
        case 'light':
          this.unloadDarkThemeCss();
          break;

        case 'dark':
          this.loadDarkThemeCss();
          break;

        default:
          this.setTheme('light');
          break;
      }
    },

    loadDarkThemeCss() {
      let file = document.createElement('link');
      file.rel = 'stylesheet';
      file.id = 'dark_theme_style_file';
      file.href = '/assets/new/style/dark-theme.css';
      let parent = document.getElementById('dark_theme_style_container');
      parent.appendChild(file);
    },

    unloadDarkThemeCss() {
      let element = document.getElementById('dark_theme_style_file');
      let parent = document.getElementById('dark_theme_style_container');

      if (element) {
        parent.removeChild(element);
      }
    


    },
  }
}
</script>

<style>
  #app {
    display: contents;
  }
</style>
